import { tw } from "@careinfo/tailwind";
import React from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
import APIS from "../../constant/EndPoint";
import AutoFillComboboxInput from "../Reusable/AutoFillComboboxInput";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import TextField from "../Reusable/TextInput";
import LocalCombobox from "../Reusable/LocalCombobox";
import Priority from "../../constant/Data";
import NumberField from "../Reusable/NumberField";
import { responsiveClassName } from "../../utils/classNames";

const CourierPickupRequestForm = (props: any) => {
  const {
    register,
    errors,
    setValue,
    getValues,
    clearErrors,
    watch,
    control,
    setOpenAddDriverPopup,
    setOpenAddVehiclePopup,
    setSenderId,
    isCreate,
  } = props;
  return (
    <div className={tw`mx-4`}>
      <div
        className={responsiveClassName(
          `grid grid-cols-1 gap-x-4 `,
          "grid grid-cols-2 gap-x-4"
        )}
      >
        <div className={tw`w-full flex `}>
          <div className={tw`w-full`}>
            <ComboboxInput
              url={APIS.VEHICLE}
              queryKey={"vehicle"}
              register={register("vehicle")}
              errors={errors?.vehicle}
              name={"vehicle"}
              label={"Vehicle Number"}
              setValue={setValue}
              placeholder={"Search vehicle"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </div>
          <button
            className={tw`border px-4  py-2 h-10 relative top-6 focus:outline-none`}
            type="button"
            onClick={() => setOpenAddVehiclePopup((prev) => !prev)}
          >
            +
          </button>
        </div>

        <div className={tw`w-full flex  `}>
          <div className={tw`w-full`}>
            <ComboboxInput
              url={APIS.DRIVER}
              queryKey={"riders"}
              register={register("driver")}
              errors={errors?.driver}
              name={"driver"}
              label={"Driver"}
              setValue={setValue}
              placeholder={"Search driver"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </div>
          <button
            className={tw`border px-4  py-2 h-10 relative top-6 focus:outline-none`}
            type="button"
            onClick={() => setOpenAddDriverPopup((prev) => !prev)}
          >
            +
          </button>
        </div>
      </div>
      <div
        className={responsiveClassName(
          `grid grid-cols-1 gap-x-4`,
          "grid grid-cols-3 gap-x-4"
        )}
      >
        <AutoFillComboboxInput
          url={APIS.MERCHANT}
          queryKey={"customer"}
          register={register("sender_name" as const, {
            required: "Sender is required",
          })}
          errors={errors?.sender_name}
          props={{
            is_active: true,
          }}
          name={`sender_name`}
          label={"Sender Name"}
          setValue={setValue}
          setSenderId={setSenderId}
          placeholder={"Search Sender"}
          getValues={getValues}
          watch={watch}
          clearErrors={clearErrors}
        />
        <PhoneNumberField
          control={control}
          label={"Sender Number"}
          name={"sender_primary_contact"}
          //@ts-ignore
          errors={errors?.sender_primary_contact}
        />
        <TextField
          label={"Sender Address"}
          register={register("sender_address")}
          errors={errors?.sender_address}
        />
        <NumberField
          value={getValues("order_count")}
          register={register("order_count")}
          errors={errors?.order_count}
          label={"Total Items"}
          disabled={isCreate}
          setValue={setValue}
          clearErrors={clearErrors}
        />
        <NumberField
          value={getValues("weight")}
          register={register("weight")}
          errors={errors?.weight}
          label={"Weight"}
          setValue={setValue}
          disabled={isCreate}
          clearErrors={clearErrors}
        />
        <LocalCombobox
          register={register("priority")}
          errors={errors?.priority}
          name={"priority"}
          label={"Priority"}
          setValue={setValue}
          data={Priority}
          disabled={isCreate}
          placeholder={"choose priority"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
      <div>
        <TextField
          label={"Note"}
          register={register(`note`)}
          errors={errors?.note}
        />
      </div>
    </div>
  );
};

export default CourierPickupRequestForm;

